import { useRouter } from "next/router";
import { leapAdvantageData } from "../../constant";
import LeapAdvantageCard from "../common/LeapAdvantageCard";
import { trackClick } from "../../scripts/segment";
import { pageName } from "../../lib/utils/events_utils";

const LeapAdvantage = ({ user, initLogin }) => {
  const router = useRouter();
  return (
    <div className="py-12 md:py-24 max-w-page-width mx-auto px-4">
      <p className="text-22 md:text-5xl text-blue-950 font-bold pt-4">
        Benefits of partnering with Leap
      </p>
      <p className="text-sm md:text-lg text-gray2-600 py-3 md:py-5">
        The thought of starting your education overseas and figuring out the
        finances for it might seem stressful. We’re here to change that.
      </p>
      <div className="flex flex-wrap justify-between pt-10 pb-6 md:pb-16">
        {leapAdvantageData.map((advantage) => (
          <div key={advantage.id} className="w-full md:w-3/10 pb-4 md:pb-0">
            <LeapAdvantageCard {...advantage} />
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <button
          onClick={() => {
            if (user) {
              router.push("/applications?clickId=37");
            } else {
              trackClick(pageName.HOME_PAGE, {
                widgetName: "Your best way into the US",
                widgetFormat: "Banner",
                contentName: "Get Started",
                contentFormat: "Button",
              });
              initLogin();
            }
          }}
          className="w-full md:w-auto bg-primary text-white text-center text-l py-4 px-20 rounded-sm font-bold hover:bg-primaryLighter"
        >
          {user ? "Resume Application" : "Get Started"}
        </button>
      </div>
    </div>
  );
};

export default LeapAdvantage;
